import { useNavigate } from 'react-router-dom';

import { Button, Paper, Typography } from '@mui/material';
import Image from '../../components/Image/Image';
import SimpleProfileCard from '../../components/SimpleProfileCard/SimpleProfileCard';

import stringUtils from '../../utils/StringUtils';

import './Denounce.scss';

function Denounce({ denounce, handleClickSeeMap }) {
  const navigate = useNavigate();

  const address = stringUtils.getPrettyAddress({ 
    city: denounce?.city?.name,
    address: denounce?.vector_focus?.address
  });
  const denounceStatus = stringUtils.getPrettyDenounceStatus(denounce?.denounce_status?.name);
  const initialDescription = denounce?.description;
  const initialPicture = denounce?.vector_focus?.picture?.url;
  const denouncer = denounce?.is_anonymous ? 'Anônimo' : denounce?.user?.first_name;
  const denouncerPicture = denounce?.is_anonymous ? null : denounce?.user?.profile_picture?.url;
  const updatedPicture = denounce?.vector_focus?.closure_picture?.url;
  const agentVisitDate = stringUtils.getPrettyDateTime(denounce?.visited_at);
  const agentFeedback = denounce?.agent_feedback || '...';

  function handleGoToDenounceUpdate() {
    navigate('/denounce-update', {
      state: {
        denounceId: denounce?.id
      }
    });
  }

  if (!denounce) return <></>;
  return (
    <Paper elevation={2} className="denounce-card">
      <div className="header">
        {initialPicture && <Image src={initialPicture} />}
      </div>
      <div className="vector-focus-item-field">
        <Typography variant="label" component="label" className="section-title">Descrição inicial</Typography>
        <Typography variant="p" component="p">{initialDescription}</Typography>
      </div>
      <div className="vector-focus-item-field">
        <Typography variant="label" component="label" className="section-title">Denunciante</Typography>
        <SimpleProfileCard
          userName={denouncer}
          userPictureURL={denouncerPicture}
        />
      </div>
      <div className="vector-focus-item-field">
        <Typography variant="label" component="label" className="section-title">Status</Typography>
        <Typography variant="p" component="p">{denounceStatus}</Typography>
      </div>
      <div className="vector-focus-item-field">
        <Typography variant="label" component="label" className="section-title">Endereço</Typography>
        <Typography variant="p" component="p">{address}</Typography>
      </div>
      <div className="vector-focus-item-field">
        <Typography variant="label" component="label" className="section-title">Geolocalização</Typography>
        <Button onClick={handleClickSeeMap}>Veja no mapa</Button>
      </div>
      <div className="vector-focus-item-field">
        <Typography variant="label" component="label" className="section-title">Acompanhamento</Typography>
        {updatedPicture && <Image src={updatedPicture} />}
      </div>
      <div className="vector-focus-item-field">
        <Typography variant="label" component="label" className="section-title">Data da última visita</Typography>
        <Typography variant="p" component="p">{agentVisitDate}</Typography>
      </div>
      <div className="vector-focus-item-field">
        <Typography variant="label" component="label" className="section-title">Feedback do agente</Typography>
        <Typography variant="p" component="p">{agentFeedback}</Typography>
      </div>
      <div className="action-buttons-containers">
        <Button onClick={handleGoToDenounceUpdate}>Atualizar denúncia</Button>
      </div>
    </Paper>
  );
}

export default Denounce;
